import gql from './index';

interface DefaultReturnFields {
  id: string;
}

interface CreateResponse<ReturnFields> {
  table: {
    affected_rows: number;
    returning: Array<DefaultReturnFields|ReturnFields>;
  };
}

export default <ReturnFields = DefaultReturnFields>(
  tableName: string,
  returnFields: string = 'id',
) => gql<CreateResponse<ReturnFields>>(`
  mutation create_${tableName}(
    $objects: [${tableName}_insert_input!]!
  ) {
    table: insert_${tableName}(
      objects: $objects
    ) {
      affected_rows
      returning {
        ${returnFields}
      }
    }
  }
`);
